import { render, staticRenderFns } from "./productsComponent.vue?vue&type=template&id=fa2b4a1a&scoped=true"
import script from "./productsComponent.vue?vue&type=script&lang=js"
export * from "./productsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2b4a1a",
  null
  
)

export default component.exports